import axios from 'axios';

import config from '../common/config';

export default {
  // Reports a Pixabay pick that was saved on an attraction. Managers only.
  recordPick(token, payload) {
    return axios.post(`${config.config.ROOT_URL}/record_shared_place_image_api`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  // Approved shared image for a place: { imageUrl: string | null }.
  getApprovedImage(token, placeId) {
    return axios.get(`${config.config.ROOT_URL}/shared_place_image_api/${encodeURIComponent(placeId)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // Admin only: places with their picked images, unreviewed places first.
  listForReview(token, page) {
    return axios.get(`${config.config.ROOT_URL}/admin/shared_place_images`, {
      params: { page },
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  approveImage(token, id) {
    return axios.post(`${config.config.ROOT_URL}/admin/shared_place_images/${id}/approve`, {}, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
  },

  rejectImage(token, id) {
    return axios.post(`${config.config.ROOT_URL}/admin/shared_place_images/${id}/reject`, {}, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
  },
};
